import { InputText, Popup } from '@ui/src';
import { DocumentsPopupsTypes } from '../types';

import cn from '../styles.module.css';

const DocumentsPopups = ({
  selectedDocumentsCounts,
  isCof,
  isCorporate,
  cofSelectedDocumentsCount,
  corporateSelectedDocumentsCount,
  setDeletePopupVisible,
  onDeleteDocuments,
  deleteInProgress,
  deletePopupVisible,
  setRenamePopupVisible,
  setSelectedDocument,
  setDocumentName,
  setNameError,
  onRename,
  renameInProgress,
  renamePopupVisible,
  selectedDocument,
  documentName,
  nameError,
  renameErrors,
}: DocumentsPopupsTypes) => {
  let documentsCounts = selectedDocumentsCounts;

  if (isCof) {
    documentsCounts = cofSelectedDocumentsCount;
  } else if (isCorporate) {
    documentsCounts = corporateSelectedDocumentsCount;
  }

  return (
    <>
      <Popup
        title={`Delete ${documentsCounts} documents?`}
        onCancelClick={() => setDeletePopupVisible(false)}
        onOkClick={onDeleteDocuments}
        cancelButtonText="Cancel"
        okButtonText={deleteInProgress ? 'Loading...' : 'Delete'}
        isVisible={deletePopupVisible}
      />
      <Popup
        title="Rename"
        onCancelClick={() => {
          setRenamePopupVisible(false);
          setSelectedDocument(undefined);
          setDocumentName('');
          setNameError('');
        }}
        onOkClick={onRename}
        cancelButtonText="Cancel"
        okButtonText={renameInProgress ? 'Loading...' : 'Rename'}
        isVisible={renamePopupVisible}
        okButtonDisabled={selectedDocument?.name === documentName}
      >
        <InputText
          name="documentName"
          value={documentName}
          onChange={(e) => setDocumentName(e.target.value)}
          placeholder="Enter document name"
          labelClassName={cn.renameInput}
          error={nameError || (renameErrors?.name?.message as string)}
        />
      </Popup>
    </>
  );
};

export default DocumentsPopups;
